<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <!-- Logo -->
      <router-link to="/" class="navbar-brand d-flex align-items-center">
        <img src="@/assets/logo/logo.png" alt="Company Logo" class="logo" />
      </router-link>

      <!-- Toggler -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navigation Links -->
<div class="collapse navbar-collapse" id="navbarNav">
  <ul class="navbar-nav ms-auto">
    <li class="nav-item">
      <router-link to="/" class="nav-link" active-class="active">Home</router-link>
    </li>
    <li class="nav-item">
      <router-link to="/about" class="nav-link" active-class="active">About</router-link>
    </li>
    <li class="nav-item">
      <router-link to="/travel-consultation" class="nav-link" active-class="active">
        Travel Consultation
      </router-link>
    </li>
    <li class="nav-item">
      <router-link to="/visa-facilitation" class="nav-link" active-class="active">
        Visa Facilitation
      </router-link>
    </li>
  </ul>

  <!-- 👇 Added ms-4 for spacing between links and icon -->
  <div class="position-relative ms-4">
    <button
      class="btn btn-outline-secondary"
      @click="toggleDropdown"
      title="Account"
    >
      <i class="bi bi-person-circle fs-4"></i>
    </button>

    <!-- Dropdown -->
    <div
      v-if="showDropdown"
      class="dropdown-menu dropdown-menu-end show mt-2 p-2 shadow"
      style="min-width: 150px;"
    >
      <template v-if="!user">
        <router-link
          to="/login"
          class="dropdown-item text-center"
          @click="closeDropdown"
        >
          Login
        </router-link>
        <router-link
          to="/register"
          class="dropdown-item text-center"
          @click="closeDropdown"
        >
          Register
        </router-link>
      </template>

      <template v-else>
        <button
          class="dropdown-item text-center text-danger"
          @click="logout"
        >
          Logout
        </button>
      </template>
    </div>
  </div>
</div>

        

    </div>
  </nav>
</template>

<script>
import { auth } from "@/firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

export default {
  name: "AppBar",
  data() {
    return {
      user: null,
      showDropdown: false,
    };
  },
  created() {
    // Listen for login/logout state
    onAuthStateChanged(auth, (currentUser) => {
      this.user = currentUser;
    });

    // Close dropdown on outside click
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    handleOutsideClick(event) {
      if (!event.target.closest(".position-relative")) {
        this.showDropdown = false;
      }
    },
    async logout() {
      try {
        await signOut(auth);
        this.user = null;
        this.closeDropdown();
        this.$router.push("/login");
      } catch (err) {
        console.error("Logout failed:", err);
      }
    },
  },
};
</script>

<style scoped>
.logo {
  height: 100px;
  width: auto;
}

.user-logo {
  height: 40px;
}

.dropdown-menu {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 1000;
  border-radius: 10px;
}

.navbar {
  padding: 0.5rem 1rem;
}

.navbar-nav .nav-item {
  margin-left: 1rem;
}

.navbar-toggler {
  border: none;
}

.nav-link {
  color: black;
  transition: color 0.3s;
}

.nav-link:hover,
.nav-link:focus,
.nav-link.active {
  color: #007bff;
}
</style>
